import React from "react";
import { observable, computed, toJS } from 'mobx';
import { observer, inject } from "mobx-react";
import paginator from "@components/Pagination/paginator";
import axios from "axios";

@inject("store")
@observer

export default class CustomerInvoices extends React.Component {


	constructor(props) {
		super(props);
		this.update = this.update.bind(this);
		this.changePage = this.changePage.bind(this);
		this.buildPagination = this.buildPagination.bind(this);
		this.state = { orderHeads: null, columnDataTypes: [], totalfound: 0, itemsperpage: 50, currentpage: 1 };

	}


	componentDidMount() {
		this.update();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.currentpage !== this.state.currentpage) {
			console.log("didupdate", prevState.currentpage, this.state.currentpage);
			this.update();
		}
	}


	componentWillUnmount() {
		if (typeof this._source != typeof undefined) {
			this._source.cancel('Operation canceled due to component unmount.');

		}
	}

	update() {

		if (typeof this._source != typeof undefined) {
			this._source.cancel('Operation canceled due to new request.');
			//console.log("reuest cancelled");
		}

		this._source = axios.CancelToken.source();
		this.props.store.reports.getInvoiceHistory(this.state.currentpage, this._source.token).then(
			result => {
				this.setState({
					orderHeads: result.data.Rows,
					columnDataTypes: result.columns,
					totalfound: result.totalfound,
					itemsperpage: result.itemsperpage,
					currentpage: result.currentpage
				});
			},
			error => {
				if (!axios.isCancel(error)) {
					alert("an error occured");
				}
			});
	}

	changePage(e, page) {
		console.log("Changepage", page);
		e.preventDefault();
		this.setState({ currentpage: page });
	}

	formatDate(date) {
		return new Intl.DateTimeFormat('en-GB',
			{
				//year: 'numeric', 
				//month: 'long', 
				//day: '2-digit' 

			}).format(Date.parse(date));
	}

	formatNumber() { }


	//formatMoney(value) {
	//	return new Intl.NumberFormat('en-GB',
	//		{
	//			style: 'currency',
	//			//currency: 'GBP',
	//			minimumFractionDigits: 0,
	//			maximumFractionDigits: 0
	//		}).format(value);
	//}


	formatString(value, fieldName) {
		switch (fieldName) {
			case "OrderStatus":
				switch (value) {
					case "under registration":
						return <span className="d-inline-block bg-info text-white text-xs p-1">{value}</span>;
					case "registered":
						return <span className="d-inline-block bg-info text-white text-xs p-1">{value}</span>;
					case "partial delivery":
						return <span className="d-inline-block bg-info text-white text-xs p-1">{value}</span>;
					case "shipped":
						return <span className="d-inline-block bg-success text-white text-xs p-1">{value}</span>;
					case "invoiced":
						return <span className="d-inline-block bg-success text-white text-xs p-1">{value}</span>;
				}
			default:
				return value;

		}
	}

	formatField(value, dataType, fieldName) {



		switch (dataType) {
			case "DateTime":
				return this.formatDate(value);

			case "String":
				return this.formatString(value, fieldName);
			//case "Money":
			//	return this.formatMoney(value);



			default:
				return value;
		}
	}


	buildPagination() {


		const paginationInfo = new paginator(
			this.state.itemsperpage,
			7
		).build(this.state.totalfound, this.state.currentpage);
		console.log("pagination", paginationInfo);
		const pages = [];
		for (
			let i = paginationInfo.first_page;
			i <= paginationInfo.last_page;
			i++
		) {
			pages.push(
				<li
					key={i + ""}
					className={i === paginationInfo.current_page ? "active" : ""}
				>
					<a href="#"
						onClick={(e) => { this.changePage(e, i); }}
					>{i + ""}</a>
				</li>
			);
		}



		return (
			<nav className="pagination">
				<div className="column">
					<ul className="pages">
						{1 !== paginationInfo.current_page && paginationInfo.first_page > 1
							? <React.Fragment>
								<li><a href="#" onClick={(e) => {
									this.changePage(e, 1);
								}}>1</a></li>
								<li>...</li>
							</React.Fragment>
							: null}
						{pages}
						{paginationInfo.total_pages !== paginationInfo.current_page &&
							paginationInfo.last_page < paginationInfo.total_pages
							? <React.Fragment>
								<li>...</li>
								<li><a href="#" onClick={(e) => {
									this.changePage(e, paginationInfo.total_pages);
								}}>{paginationInfo.total_pages}</a></li>

							</React.Fragment>
							: null}


					</ul>
				</div>

			</nav>);
	}



	render() {





		if (!this.props.store.navigation.getCustomerId()) {
			return <div>Error: No customer choosen customer</div>;
		}

		if (!this.state.orderHeads) {
			return <div>Loading invoices...</div>;
		}

		if (this.state.orderHeads.length === 0) {
			return <div><strong>No invoices found!</strong></div>;
		}

        const columns = Object.keys(this.state.columnDataTypes);//Object.keys(this.state.orderHeads[0]);
		const columnsDataType = this.state.columnDataTypes;
		const pagination = this.buildPagination();

		return (<div>
			{pagination}
			<div className="table-responsive text-sm">
				<table className="table table-hover margin-bottom-none table-sm">
					<thead>
						<tr>
							{columns.map(column => {
								return (<th key={column}>{column}</th>);
							})}
						</tr>
					</thead>
					<tbody>
						{this.state.orderHeads.map(row => {
							return (
								<tr key={row[columns[0]]}>
									{columns.map((column, index) => {
										const dataType = columnsDataType[column];
										return (
											<td key={column}>
												{index === 0 && row["DocumentExists"] ?
													<a
														href={"/Umbraco/Api/MyPages/InvoiceHistoryDocument?cid=" + this.props.store.navigation.getCustomerId() + "&DocumentId=" + row[column]}
														className="text-medium invoice-link navi-link"
													>{this.formatField(row[column], dataType, column)}</a>
													: this.formatField(row[column], dataType, column)}
											</td>);
									})}
								</tr>
							);
						})}
					</tbody>
				</table>

				{pagination}
			</div>


		</div>);

	}
}